import React from "react";

interface HistoryEventCardProps {
  title: string;
  date: string;
  rank: number;
  points: number;
  eventGroupName?: string;
}

/** UTC ISO 8601 datetime string → JST "yyyy / mm / dd hh:mm" フォーマットに変換 */
const formatEventDate = (isoDateString: string): string => {
  if (!isoDateString) return "";
  try {
    const d = new Date(isoDateString);
    if (Number.isNaN(d.getTime())) return isoDateString;
    // UTCにJST offset（+9時間）を加算
    const jst = new Date(d.getTime() + 9 * 60 * 60 * 1000);
    const yyyy = jst.getUTCFullYear();
    const mm = String(jst.getUTCMonth() + 1).padStart(2, "0");
    const dd = String(jst.getUTCDate()).padStart(2, "0");
    const hh = String(jst.getUTCHours()).padStart(2, "0");
    const min = String(jst.getUTCMinutes()).padStart(2, "0");
    return `${yyyy} / ${mm} / ${dd} ${hh}:${min}`;
  } catch {
    return isoDateString;
  }
};

const HistoryEventCard: React.FC<HistoryEventCardProps> = ({
  title,
  date,
  rank,
  points,
  eventGroupName,
}) => (
  <div className="relative bg-white rounded-[20px] p-4 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100 mb-4 flex items-center justify-between group hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)] hover:border-emerald-200 transition-all duration-300 text-left">
    <div className="flex flex-col">
      {eventGroupName && (
        <span className="text-[9px] font-bold text-emerald-500 uppercase tracking-widest mb-0.5">
          {eventGroupName}
        </span>
      )}
      <h4 className="font-bold text-slate-800 text-[14px] leading-snug mb-1">
        {title}
      </h4>
      <span className="text-[10px] text-slate-400 font-bold uppercase tracking-widest">
        {formatEventDate(date)}
      </span>
    </div>
    <div className="flex gap-4 items-center shrink-0">
      <div className="text-right">
        <p className="text-[8px] font-bold text-slate-400 uppercase">順位</p>
        <p className="font-black text-slate-700 text-sm">{rank}位</p>
      </div>
      <div className="text-right min-w-[40px]">
        <p className="text-[8px] font-bold text-emerald-500 uppercase">獲得</p>
        <p className="font-black text-emerald-600 text-sm">+{points}pt</p>
      </div>
    </div>
  </div>
);

export default HistoryEventCard;
